var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEfficiency(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.421,
    y1: -0.29,
    x2: 3.246,
    y2: 1.634,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#9a00ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1718ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -2.282,
    y1: -1.601,
    x2: 2.384,
    y2: 1.921,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.25,
    y1: -3.314,
    x2: 0.884,
    y2: 6.353,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -1.08,
    y1: -0.694,
    x2: 3.587,
    y2: 2.828,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.36,
    y1: -1.281,
    x2: 1.249,
    y2: 2.053,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -0.762,
    y1: -2.113,
    x2: 0.847,
    y2: 1.22,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179",
    transform: "translate(-900 -4633)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2",
    "data-name": 2,
    transform: "translate(894.9 4626.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138_00000005258044509218015940000015033189784534704305_",
    width: 10.502,
    height: 52.742,
    transform: "translate(54.974 35.904)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138_00000018929501010478631490000009618236796592472233_",
    width: 10.502,
    height: 28.822,
    transform: "translate(87.763 55.274)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138_00000075128388573433099390000004258054810744368555_",
    width: 77.247,
    height: 10.502,
    transform: "translate(21.018 55.274)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18_00000023242825439025304880000013203626529499344801_",
    d: "M62.987,20.268V35.787H47.468V20.268ZM40.7,13.5V42.672H69.872V13.5Z",
    transform: "translate(4.939 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175",
    transform: "translate(11.1 55.274)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138_00000173141849404945156440000015707213144243461268_",
    width: 10.502,
    height: 28.822,
    transform: "translate(9.918)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19_00000174567497746177560520000004390047732021821062_",
    d: "M18.218,75.818H34.437V92.037H18.218ZM11.1,99.155H41.555V68.7H11.1Z",
    transform: "translate(-11.1 -46.063)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_19_00000019661618859126123650000006065167912539428500_",
    d: "M75.418,75.818H91.637V92.037H75.418ZM68.3,99.155H98.755V68.7H68.3Z",
    transform: "translate(9.545 9.211)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_215",
    "data-name": "Rectangle 215",
    width: 108,
    height: 108,
    transform: "translate(900 4633)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEfficiency);
export default __webpack_public_path__ + "static/media/efficiency.80cfc0343b949f15948c2d87912ed34f.svg";
export { ForwardRef as ReactComponent };